/**
 * 部件英文名标准表（欧博术语表，2026-10-15 客户提供，作为"标准答案"）。
 *
 * 爆炸图右侧部件列表、悬浮提示、部件弹窗里的英文名，都以这张表为准：
 * 命中这里的词条就按这里的写法显示，不再按 FEATURE_WORDS_EN 逐词拼。
 * 想核对有没有跑偏，跑 `node scripts/check-part-glossary.mjs`。
 *
 * 注意：标准写法里 "Shell and Tube" 不加连字符、"Y-Strainer" 带连字符、
 * "Pre-efficiency" 带连字符 —— 和表里不一致的地方都要以表为准。
 */
export const PART_GLOSSARY_EN = {
  // 组合式空调机组 / 末端（风柜、过滤器段等）
  '亚高效过滤器组件': 'Sub-high Efficiency Filter Assembly',
  '初-中效过滤器组件': 'Pre & Medium Filter Assembly',
  '前段盘管挡风板': 'Front Coil Baffle Plate',
  '前段表冷器组件': 'Front Cooling Coil Assembly',
  '后段盘管挡风板': 'Coil Baffle Plate Assembly (Downstream Side)',
  '后段表冷器组件': 'Rear Cooling Coil Assembly',
  '均流网组件': 'Flow Equalizing Screen Assembly',
  '接水盘': 'Drain Pan',
  '电风机组件': 'Electric Fan Assembly',
  '蒸发器组件': 'Evaporator Assembly',
  '中效组件': 'Medium Filter Assembly',
  '初效组件': 'Pre-efficiency Filter Assembly',
  '加湿器组件': 'Humidifier Assembly',
  '水盘组件': 'Drain Pan Assembly',
  '电加热组件': 'Electric Heater Assembly',
  '电预热组件': 'Electric Preheat Assembly',
  '外挂初效过滤器组件': 'External Pre-filter Assembly',
  '膨胀罐': 'Expansion Tank',
  'Y型过滤器': 'Y-Strainer',
  '出水管组件': 'Water Outlet Pipe Assembly',
  '离心泵': 'Centrifugal Pump',
  '补水管组件': 'Make-up Water Pipe Assembly',
  '进水管组件': 'Water Inlet Pipe Assembly',
  // 转轮除湿机
  '再生风机': 'Regeneration Fan',
  '电加热箱': 'Electric Heating Section',
  '保温风管': 'Insulated Duct',
  '转轮架组件': 'Rotor Frame Assembly',
  '电机': 'Motor',
  '翅片': 'Fin',
  '风扇': 'Fan',
  '风机': 'Supply Fan',
  '尼龙网组件': 'Nylon Mesh Assembly',
  '盘管': 'Coil',
  // 主机四大件
  '涡旋压缩机': 'Scroll Compressor',
  '涡旋式压缩机': 'Scroll Compressor',
  '壳管式蒸发器': 'Shell-and-Tube Evaporator',
  '壳管式冷凝器': 'Shell-and-Tube Condenser',
  '干式壳管蒸发器': 'Dry Expansion Shell-and-Tube Evaporator',
  '电子膨胀阀': 'Electronic Expansion Valve',
  '冷凝器': 'Condenser',
  '蒸发器': 'Evaporator',
  '气悬浮压缩机': 'Air Bearing Centrifugal Compressor'
}

/** 表里的中文词条（按长度倒序，给逐词兜底用） */
export function glossaryTerms() {
  return Object.keys(PART_GLOSSARY_EN)
}
